<template>
  <div class="home-container">
    <div class="main-container">
      <el-skeleton :loading="loading" animated>
        <template slot="template">
          <el-skeleton-item
            variant="image"
            style="width: 100%; height: 420px"
          />
          <div style="padding: 32px 0">
            <el-skeleton-item variant="h3" style="width: 100%" />
            <div
              style="
                display: flex;
                align-items: center;
                justify-items: space-between;
                margin-top: 32px;
                height: 16px;
              "
            >
              <el-skeleton-item variant="text" style="margin-right: 16px" />
              <el-skeleton-item variant="text" style="width: 30%" />
            </div>
            <el-skeleton-item
              variant="h3"
              style="width: 100%; margin-top: 32px"
            />
          </div>
        </template>
      </el-skeleton>
      <div v-show="!loading">
        <!-- 轮播图 -->
        <section>
          <el-carousel
            trigger="click"
            indicator-position="none"
            :interval="5000"
          >
            <el-carousel-item
              v-for="(item, index) in filteredCarouselList"
              :key="index"
            >
              <div class="carousel-box">
                <img
                  :src="`https://dirc.sjtu.edu.cn/api/v1/homepage/img?id=${item.id}`"
                  width="100%"
                />
              </div>
              <article class="image-des">
                {{
                  lang === "zh-cn" ? item.description_zh : item.description_en
                }}
              </article>
            </el-carousel-item>
          </el-carousel>
        </section>
        <!-- 简介 -->
        <section class="iiot-des">
          <article>
            2022年11月9日，上海交通大学电子工程系王新兵教授课题组在地学知识图谱的交叉学科研究领域取得重要进展，一系列学术成果在法国巴黎联合国教科文组织总部召开的DDE开放科学论坛（DDE
            Open Science
            Forum）进行成果发布，这一活动由联合国教科文组织UNESCO、国际地质科学联盟IUGS、国际基础科学促进可持续发展年IYBSSD和深时数字地球项目DDE共同承办，吸引了来自全球超过150名顶级科学家的共同参与。
          </article>
        </section>
        <!-- 招聘信息（新增） -->
        <section class="normal-card">
          <el-row>
            <el-col :span="24">
              <h2 class="enroll-title">数据智能研究所招聘通知（长期有效）</h2>
              <article class="normal-des">
                电子系数据智能研究所招聘 AI 算法工程师，详情请点击
                <a class="link-style" :href="engineerRecruitPdf" target="_blank" rel="noopener noreferrer">
                  招聘信息
                </a>
                进行查看
              </article>
            </el-col>
          </el-row>
        </section>
        <!-- 招生信息 -->
        <section class="normal-card">
          <el-row>
            <!-- <el-col :span="10"
              ><img
                src="https://iaccount.acemap.cn/static/images/case_bg1.jpg"
                alt=""
                srcset=""
                width="100%"
            /></el-col> -->
            <el-col :span="24">
              <h2 class="enroll-title">数据智能研究所招生通知</h2>
              <article class="normal-des">
                电子系数据智能研究所招收学术型/专业学位硕士，学术型博士。请有意向攻读数据智能研究所研究生的同学将个人简历发至感兴趣的导师邮箱。详情请点击
                <span
                  class="link-style"
                  @click="$router.push({ name: 'recruitment' })"
                  >招生主页</span
                >
              </article>
            </el-col>
          </el-row>
        </section>
        <!-- 新闻 -->
        <section class="normal-card">
          <h2>Recent News</h2>
          <ul>
            <li
              class="publication-item"
              v-for="(news, index) in newsList"
              :key="index"
            >
              <img :src="newImg" alt="" />
              <span v-if="lang === 'zh-cn'">
                <span class="news">{{ news.time }}</span>
                <span class="news">{{ news.event_zh }}</span>
                <span v-show="news.url"
                  ><a class="link-style" :href="news.url" target="_blank"
                    >更多 >></a
                  ></span
                >
              </span>
              <span v-else>
                <span class="news">{{ news.time }}</span>
                <span class="news">{{ news.event_en }}</span>
                <span v-show="news.url"
                  ><a class="link-style" :href="news.url" target="_blank"
                    >Read More >></a
                  ></span
                >
              </span>
            </li>
          </ul>
        </section>
        <!-- 项目列表 -->
        <section class="normal-card">
          <h2>Projects</h2>
          <section
            class="projects-list"
            v-for="(item, index) in projectList"
            :key="index + 'pro'"
          >
            <el-row :gutter="32" v-if="index % 2">
              <el-col :span="8" style="float: right">
                <img
                  :src="`https://dirc.sjtu.edu.cn/api/v1/project/img_1?pid=${item.project_id}`"
                  style="margin-bottom: 8px"
                  width="100%"
                />
              </el-col>
              <el-col :span="16" :class="{ 'text-float': item.showMore }">
                <h2
                  class="p-title"
                  :class="item.project_sys_url ? 'hover-underline' : ''"
                  @click="linkTo(item.project_sys_url)"
                >
                  {{
                    lang === "zh-cn"
                      ? item.project_name_zh
                      : item.project_name_en
                  }}
                </h2>

                <article
                  class="p-details"
                  v-if="item.project_intro_zh.length > sliceLength"
                >
                  <span v-if="!item.showMore">
                    {{
                      lang === "zh-cn"
                        ? item.project_intro_zh.slice(0, sliceLength)
                        : item.project_intro_en.slice(0, sliceLength)
                    }}…
                  </span>
                  <span v-else>{{
                    lang === "zh-cn"
                      ? item.project_intro_zh
                      : item.project_intro_en
                  }}</span>
                  <span
                    v-if="!item.showMore"
                    class="link-style"
                    style="margin-left: 4px"
                    @click="showMore(index, true)"
                    >More >></span
                  >
                  <span
                    v-else
                    class="link-style"
                    style="margin-left: 4px"
                    @click="showMore(index, false)"
                    >&lt;&lt; Hide</span
                  >
                </article>
                <article class="p-details" v-else>
                  {{
                    lang === "zh-cn"
                      ? item.project_intro_zh
                      : item.project_intro_en
                  }}
                </article>
              </el-col>
            </el-row>
            <el-row :gutter="32" v-else>
              <el-col :span="8">
                <img
                  :src="`https://dirc.sjtu.edu.cn/api/v1/project/img_1?pid=${item.project_id}`"
                  style="margin-bottom: 8px"
                  width="100%"
                />
              </el-col>
              <el-col :span="16" :class="{ 'text-float': item.showMore }">
                <h2
                  class="p-title"
                  :class="item.project_sys_url ? 'hover-underline' : ''"
                  @click="linkTo(item.project_sys_url)"
                >
                  {{
                    lang === "zh-cn"
                      ? item.project_name_zh
                      : item.project_name_en
                  }}
                </h2>
                <article
                  class="p-details"
                  v-if="item.project_intro_zh.length > sliceLength"
                >
                  <span v-if="!item.showMore">
                    {{
                      lang === "zh-cn"
                        ? item.project_intro_zh.slice(0, sliceLength)
                        : item.project_intro_en.slice(0, sliceLength)
                    }}…
                  </span>
                  <span v-else>{{
                    lang === "zh-cn"
                      ? item.project_intro_zh
                      : item.project_intro_en
                  }}</span>
                  <span
                    v-if="!item.showMore"
                    class="link-style"
                    style="margin-left: 4px"
                    @click="showMore(index, true)"
                    >More >></span
                  >
                  <span
                    v-else
                    class="link-style"
                    style="margin-left: 4px"
                    @click="showMore(index, false)"
                    >&lt;&lt; Hide</span
                  >
                </article>
                <article class="p-details" v-else>
                  {{
                    lang === "zh-cn"
                      ? item.project_intro_zh
                      : item.project_intro_en
                  }}
                </article>
              </el-col>
            </el-row>
          </section>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import carouselImg from "../assets/image/carousel/1.jpeg";
import newImg from "../assets/image/new.png";
// import picture1 from "../assets/image/side-carousel/1.png";
// import picture2 from "../assets/image/side-carousel/2.png";
// import picture3 from "../assets/image/side-carousel/3.jpeg";
// import VuePerfectScrollbar from "vue-perfect-scrollbar";
import enroll from "../assets/image/enroll.png";
import { fetchNews, fetchHomePage } from "@/api/message.js";
export default {
  name: "Home",
  components: {
    // VuePerfectScrollbar,
  },
  computed: {
    lang() {
      return this.$store.state.lang;
    },
    filteredCarouselList() {
      return this.carouselList.filter((item) => item.id !== 11);
    },
  },
  data() {
    return {
      loading: false,
      sliceLength: 200,
      carouselList: [
        {
          url: carouselImg,
          des: "THIS IS DESCRIPTOPN",
        },
        {
          url: carouselImg,
          des: "THIS IS DESCRIPTOPN",
        },
        {
          url: carouselImg,
          des: "THIS IS DESCRIPTOPN",
        },
        {
          url: carouselImg,
          des: "THIS IS DESCRIPTOPN",
        },
      ],
      publicationList: [
        [
          '[IPSN] Meng Jin, Y. He, Y. Liu, X. Wang, "Furtively Connecting IoT Devices with Random Noise", ACM/IEEE IPSN 2022.',
          "[INFOCOM] J. Tang, L. Fu, Jiaxin Ding, X. Wang, G. Chen, “Connectivity Maintenance in Uncertain Networks under Adversarial Attack”, in Proc. of IEEE INFOCOM 2022.",
          "[TIT] X. Liu, Luoyi Fu, X. Wang, C. Zhou, “On the Similarity between von Neumann Graph Entropy and Structural Information: Interpretation, Computation, and Applications”, in IEEE Transactions on Information Theory, accepted, 2022.",
          '[ICNP] P. Cao, Shizhen Zhao, M. Teh, Y. Liu, X. Wang, "TROD: Evolving From Electrical Data Center to Optical Data Center," in ICNP, Virtual Event, November, 2021.',
          '[IPSN] Meng Jin, X. Wang, " Pairing IoT Devices with Spatial Keys", ACM/IEEE IPSN 2022.',
        ],
        [
          '[IPSN] Meng Jin, Y. He, Y. Liu, X. Wang, "Furtively Connecting IoT Devices with Random Noise", ACM/IEEE IPSN 2022.',
          "[INFOCOM] J. Tang, L. Fu, Jiaxin Ding, X. Wang, G. Chen, “Connectivity Maintenance in Uncertain Networks under Adversarial Attack”, in Proc. of IEEE INFOCOM 2022.",
          "[TIT] X. Liu, Luoyi Fu, X. Wang, C. Zhou, “On the Similarity between von Neumann Graph Entropy and Structural Information: Interpretation, Computation, and Applications”, in IEEE Transactions on Information Theory, accepted, 2022.",
          '[ICNP] P. Cao, Shizhen Zhao, M. Teh, Y. Liu, X. Wang, "TROD: Evolving From Electrical Data Center to Optical Data Center," in ICNP, Virtual Event, November, 2021.',
          '[IPSN] Meng Jin, X. Wang, " Pairing IoT Devices with Spatial Keys", ACM/IEEE IPSN 2022.',
        ],
        [
          '[IPSN] Meng Jin, Y. He, Y. Liu, X. Wang, "Furtively Connecting IoT Devices with Random Noise", ACM/IEEE IPSN 2022.',
          "[INFOCOM] J. Tang, L. Fu, Jiaxin Ding, X. Wang, G. Chen, “Connectivity Maintenance in Uncertain Networks under Adversarial Attack”, in Proc. of IEEE INFOCOM 2022.",
          "[TIT] X. Liu, Luoyi Fu, X. Wang, C. Zhou, “On the Similarity between von Neumann Graph Entropy and Structural Information: Interpretation, Computation, and Applications”, in IEEE Transactions on Information Theory, accepted, 2022.",
          '[ICNP] P. Cao, Shizhen Zhao, M. Teh, Y. Liu, X. Wang, "TROD: Evolving From Electrical Data Center to Optical Data Center," in ICNP, Virtual Event, November, 2021.',
          '[IPSN] Meng Jin, X. Wang, " Pairing IoT Devices with Spatial Keys", ACM/IEEE IPSN 2022.',
        ],
        [
          '[IPSN] Meng Jin, Y. He, Y. Liu, X. Wang, "Furtively Connecting IoT Devices with Random Noise", ACM/IEEE IPSN 2022.',
          "[INFOCOM] J. Tang, L. Fu, Jiaxin Ding, X. Wang, G. Chen, “Connectivity Maintenance in Uncertain Networks under Adversarial Attack”, in Proc. of IEEE INFOCOM 2022.",
          "[TIT] X. Liu, Luoyi Fu, X. Wang, C. Zhou, “On the Similarity between von Neumann Graph Entropy and Structural Information: Interpretation, Computation, and Applications”, in IEEE Transactions on Information Theory, accepted, 2022.",
          '[ICNP] P. Cao, Shizhen Zhao, M. Teh, Y. Liu, X. Wang, "TROD: Evolving From Electrical Data Center to Optical Data Center," in ICNP, Virtual Event, November, 2021.',
          '[IPSN] Meng Jin, X. Wang, " Pairing IoT Devices with Spatial Keys", ACM/IEEE IPSN 2022.',
        ],
      ],
      projectList: [
        {
          project_id: 1,
          project_name_zh: "图文数一体化的地学文献平台",
          project_name_en: "DDE Scholar",
          project_intro_zh:
            "DDE Scholar系统是集学术搜索、分析与可视化为一体的智能地学文献平台，从多数据源实时更新学术数据。截止至目前，平台收录了发表在535个期刊来源上的超过3,600,000篇论文和4,000,000位学者信息。系统面向涵盖地学领域学者、论文及其所含图文数数据、机构、关键词、刊物、科研项目等的地学学术大数据，基于已有地球科学叙词表提取并建立地球科学数据元(DataElement)，用于后续提供简单明确的数据汇交标准，便于数据管理、各类知识图谱构建等。在此基础上，运用所提出的地学知识挖掘与表示技术，建立面向地理各级学科的关键词脉络体系及领域论文引用脉络体系；构建涵盖地理学术元素间语时空多重关联的地学学术知识图谱同时建立文献关联、作者关联、学科关联等，进而挖掘学者、机构研究领域、领域代表学者及地理实体关键属性，从而帮助科研人员从海量地理学术数据中发现知识并建立关联。运用所提出的地学知识更新与融合技术，搭建分布式地学学术数据采集与存算平台，获取不断发表的新论文解析其中的图文数元素在语时空多重范畴上的关联，进而连同新学者等信息融合进地学知识图谱中；并克服学者同名、机构名称多样等知识歧义问题以保障图谱的一致性。运用所提出的地学知识交互与呈现技术，搭建智能地学学术问答与推荐系统，实现面向地理学者、领域、论文等学术元素间逻辑关系的智能检索，以及相关地学领域学者和论文等的推荐；构建地学学者画像、机构画像、刊物画像、领域画像等以帮助学者对其形成全面了解；面向地学领域基于地学图谱可视化技术，对领域内学者、关键词、机构、论文间的关系全貌，以及领域关键词、论文间的层级脉络进行可视化，帮助学者直观认识地学学术空间并把握地学领域广度、发展趋势和论文学术价值。",
          project_intro_en: "",
          project_catalog: "DDE",
          project_tutor: ["王新兵"],
          project_img_url: [],
          project_sys_url: "https://ddescholar.acemap.info/",
          project_start_date: "2020-01-01",
        },
        {
          project_id: 3,
          project_name_zh: "深铲-一站式地学文献挖掘平台",
          project_name_en: "Shen Chan",
          project_intro_zh:
            "地球科学科学数据库是结构化和经过验证的研究结果的集合，由各种测量数据、样本属性或图像数据组成，在数据驱动的地球科学研究中发挥着核心作用，可以帮助地球科学家发现地球上的未知现象和新见解。为了获得足够多的高质量数据，地球科学家经常查阅大量已发表的文献，从中定位和提取有用的数据（例如，表格、图形、地图等）构建科学数据库。然而，单个研究团队几乎不可能依靠人力从数十万份文档中手动收集和组织这些零散的数据，而且每年新发表的文献数量还在不断增加，这给这一工作带来了更大的困难。基于此，我们设计了深铲，一个基于人工智能的可协同一站式地学文献数据挖掘平台，以人在回路的形式协助地学研究团队完成数据抽取、数据聚合、科学数据库建设等工作。 深铲使用human-ai collaboration思想的人机交互设计为没有人工智能背景的地球科学家提供了利用人工智能推动科学研究的平台。地球科学家可以轻松使用深铲处理PDF格式的文献或报告，从中提取表格数据、文本、图片并形成结构化的数据集，而人在回路的机器学习模块将不断利用用户的标注以及提取行为，进行自我提升。自2021年5月上线以来，深时数字地球计划（DDE）中已经有来自 37 个团队超过250 名用户使用深铲进行数据挖掘，共创建了240 多个项目，处理了超过 47,000 份文献以及报告。",
          project_intro_en: "",
          project_catalog: "DDE",
          project_tutor: ["王新兵", "温颍"],
          project_img_url: [],
          project_sys_url: "https://gakg.acemap.info/",
          project_start_date: "2020-01-01",
        },
        {
          project_id: "17",
          project_name_zh: "超低功耗智能物联网体系结构和设计方法",
          project_name_en:
            "Ultra-low-power intelligent IoT architecture and designs",
          project_intro_zh:
            "智能物联网是物联网的发展趋势，但是现有的支撑硬件系统和底层协议无法满足物联网的超低功耗需求。为了实现超低功耗的智能物联网，需要重新构造物联网的体系结构，并对核心的通信、计算单元进行重新设计。针对物联网的低功耗通信需求，研究反向散射通信系统，包括反向散射标签硬件、反向散射通信数字基带、反向散射通信接收机的DSP以及反向散射通信网络的协议。主要研究内容包括支持uW级别通信功耗的OFDMA Wi-Fi反向散射网络。针对反射通信网络规模扩大的难题，研究基于低功耗数字频率合成技术的OFDMA反射通信系统，并研究实现",
          project_intro_en:
            "The intelligent Internet of Things is the development trend of the Internet of Things, but the existing supporting hardware systems and underlying protocols cannot meet the ultra-low power consumption requirements of the Internet of Things. To realize the",
          project_catalog: "IOT",
          project_tutor: "田晓华",
          project_sys_url: "",
          project_start_date: "2020-01-01",
        },
      ],
      enroll,
      WangInfo: {
        name_zh: "王新兵 教授",
        name_us: "Prof. Xinbing Wang",
        title_us:
          "Distinguished Professor, Executive Director, Ph.D. Supervisor in both EE & CS Department School of Electronic Information & Electrical Engineering, Shanghai Jiao Tong University.",
        title_zh: "特聘教授，博士生导师，数据智能研究所执行主任",
        sub_title_zh: "执行主任",
        sub_title_us: "Supervisor",
      },
      newsList: [],
      pictureList: [
        {
          // img: picture1,
          id: "8",
          info: "每周通信",
        },
        {
          id: "9",
          // img: picture2,
          info: "教材",
        },
        {
          id: "10",
          // img: picture3,
          info: "马克杯墙",
        },
      ],
      newImg,
      engineerRecruitPdf: process.env.BASE_URL + "job_requirements_dirc2025.pdf",
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    linkTo(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },
    initData() {
      fetchHomePage().then((res) => {
        this.carouselList = res.data;
        setTimeout(() => {
          this.loading = false;
        }, 3000);
      });
      fetchNews().then((res) => {
        this.newsList = res.data;
        // const newsList = res.data;
        // newsList.sort((a, b) => {
        //   return parseInt(b.id) - parseInt(a.id);
        // });
        // this.handleNewList(newsList);
      });
    },
    handleNewList(list) {
      const flag = 8;
      const arr = [];
      for (var i = 0; i < list.length; i += flag) {
        arr.push(list.slice(i, i + flag));
      }
      this.newsList = arr;
    },
    showMore(index, flag) {
      const item = this.projectList[index];
      item["showMore"] = flag;
      this.$set(this.projectList, index, item);
    },
  },
};
</script>
<style lang="less">
.home-container {
  .el-carousel__container {
    height: 730px;
    @media screen and (max-width: 2400px) {
      height: 640px;
    }
    /* 针对最大宽度为980像素的设备 */
    @media screen and (max-width: 1440px) {
      height: 530px;
    }
    /* 针对最大宽度为1100像素的设备 */
    @media screen and (max-width: 1100px) {
      height: 400px;
    }
    /* 针对最大宽度为768像素的设备 */
    @media screen and (max-width: 768px) {
      height: 300px;
    }
    /* 针对最大宽度为580像素的设备 */
    @media screen and (max-width: 580px) {
      height: 250px;
    }

    /* 针对最大宽度为480像素的设备 */
    @media screen and (max-width: 480px) {
      height: 180px;
    }
  }
}
</style>
<style lang="less" scoped>
.home-container {
  background: #ededed;
  padding: 64px 36px;
  .carousel-box {
    background: #fff;
    width: 100%;
    height: 100%;
    img {
      height: 100%;
    }
  }
  .image-des {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: #4a4d50;
    padding: 16px 12px;
    font-size: 14px;
    color: #fff;
  }
  .iiot-des {
    background: #fff;
    padding: 36px;
    font-size: 16px;
    outline: solid 1px #dedede;
    margin-bottom: 32px;
    h1 {
      font-size: 36px;
      font-weight: 800;
      margin-bottom: 18px;
    }
    article {
      text-indent: 32px;
      line-height: 22px;
      text-align: justify;
    }
  }
  .projects-list {
    // margin-bottom: 32px;
    background: #fff;
    padding: 36px;
    font-size: 16px;
    border-top: 1px solid #dedede;
    // outline: solid 1px #dedede;
    text-align: left;
    .text-float {
      float: none;
      width: 100%;
    }
    .p-title {
      font-size: 20px;
      line-height: 24px;
      font-weight: 600;
      margin-bottom: 24px;
    }
    .hover-underline {
      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
    .p-details {
      font-size: 16px;
      line-height: 20px;
    }
  }
  .normal-card {
    background: #fff;
    padding: 24px;
    font-size: 16px;
    outline: solid 1px #dedede;
    border-top: solid 4px #4a4d50;
    margin-bottom: 32px;
    h2 {
      font-weight: 800;
      font-size: 20px;
      margin-bottom: 16px;
      text-align: left;
    }
    .normal-des {
      line-height: 20px;
      font-size: 16px;
    }
    .enroll-title {
      margin-top: 20px;
      text-align: center;
    }
  }
  .publication-item {
    list-style: inside;
    text-align: left;
    line-height: 24px;
    margin-bottom: 8px;
    display: flex;
    align-items: flex-start;
    .news {
      margin-right: 4px;
    }
    img {
      width: 24px;
      vertical-align: -webkit-baseline-middle;
      margin-right: 6px;
      padding-top: 4px;
    }
  }
  .wang-title {
    font-size: 20px;
    font-weight: 800;
    margin-bottom: 8px;
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .wang-position {
    font-weight: 600;
    margin-bottom: 16px;
  }
  .wang-des {
    text-align: justify;
    word-break: break-all;
    line-height: 20px;
    font-size: 16px;
  }
  .read-more {
    margin-top: 8px;
    text-align: left;
    a {
      color: #2c3e50;
    }
  }
}
.max-width {
  max-width: 1440px;
  min-width: 740px;
  margin: 0 auto;
}
.link-style {
  color: #4a4d50;
  text-decoration: underline;
  font-weight: 500;
  cursor: pointer;
}
.picture-list {
  .image-des {
    background: #4a4d50a8;
  }
}
</style>
